import React from "react";
import Styles from "./CardGuide.module.css";
import { Link } from "react-router-dom";

import StarRoundedIcon from "@mui/icons-material/StarRounded";
import { useTranslation } from "react-i18next";

function CardGuide({
	idGuide,
	name,
	image,
	imgCover,
	province,
	rate,
	perHour,
	noOfReviews,
	quote,
	ProgramsData,
	UsersReviews,
}) {
	const { t, i18n } = useTranslation();

	const isRtl =
		i18n.language === "ar" || i18n.language === "ku";

	const stars = [1, 2, 3, 4, 5];
	
	return (
		<div
			// className={isRtl ? Styles.CardRtl : Styles.Card}
			className={Styles.Card}
		>
			<Link
				to={`/guidePage/${idGuide}`}
				state={{
					idGuide: idGuide,
					name: name,
					image: image,
					imgCover: imgCover,
					province: province,
					rate: rate,
					noOfReviews: noOfReviews,
					ProgramsData: ProgramsData,
					UsersReviews: UsersReviews,
				}}
				className={Styles.link}
			>
				<img
					className={Styles.imgCard}
					src={image}
					alt={name}
				/>
				<div className={Styles.cardInfoContainer}>
					<h2
						// className={Styles.h2}
						className={isRtl ? Styles.h2Rtl : Styles.h2}
					>
						{name}
					</h2>
					<p
						// className={Styles.province}
						className={
							isRtl ? Styles.provinceRtl : Styles.province
						}
					>
						{province}
					</p>
					<p
						// className={Styles.rate}
						className={isRtl ? Styles.rateRtl : Styles.rate}
					>
						{stars.map((star) => (
							<span
								key={star}
								className={
									star <= rate
										? `${Styles.star} ${Styles.filled}`
										: Styles.star
								}
							>
								<StarRoundedIcon fontSize='large' />
							</span>
						))}
					</p>
					<p
						// className={Styles.hour}
						className={isRtl ? Styles.hourRtl : Styles.hour}
					>
						<span>{perHour}$</span>/{t("GuideProfile.h")}
					</p>
					<p
						className={
							isRtl ? Styles.reviewsRtl : Styles.reviews
						}

						// className={Styles.reviews}
					>
						{noOfReviews}
						<span> {t("GuideProfile.reviews")}</span>
					</p>
					<p
						className={
							isRtl ? Styles.quoteRtl : Styles.quote
						}

						// className={Styles.quote}
					>
						{quote}
					</p>
				</div>
			</Link>
		</div>
	);
}

export default CardGuide;
